import React from 'react';
import { formatMessageDay } from '../utils';
import styles from './MessageDayDivider.module.css';

interface MessageDayDividerProps {
  dayKey: string;
}

const MessageDayDivider: React.FC<MessageDayDividerProps> = ({ dayKey }) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{formatMessageDay(dayKey)}</span>
    </div>
  );
};

export default MessageDayDivider;
